import { watch, onBeforeUnmount } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const MAX_SHOWN = 99;

export const formatUnreadTitle = (baseTitle, count) => {
  if (!count) return baseTitle;
  const shown = count > MAX_SHOWN ? `${MAX_SHOWN}+` : count;
  return `(${shown}) ${baseTitle}`;
};

export function useUnreadTabTitle() {
  const allUnreadCount = useMapGetter(
    'conversationUnreadCounts/getAllUnreadCount'
  );
  const baseTitle = document.title;

  watch(
    allUnreadCount,
    count => {
      document.title = formatUnreadTitle(baseTitle, count);
    },
    { immediate: true }
  );

  onBeforeUnmount(() => {
    document.title = baseTitle;
  });
}
